import React from 'react'

import ColorSwatch from './colorSwatch'
import { ButtonGroupWrap } from './buttonGroup'
const map = {
  Red: '#DD4343',
  Burgundy: '#AB2431',
  Blue: '#1261A0',
  Black: '#202020',
  Gray: '#A0A0A0',
  Silver: 'linear-gradient(#D5D5D5, #AFAFAF)',
  Brown: '#6D462A',
  Green: '#006400',
  White: '#FDFDFD',
  Yellow: '#FEDD37',
  Gold: 'linear-gradient(#F4DF99, #E0C274)',
  Pink: '#F493B4',
  Beige: '#CFB48E',
  Orange: '#F79F1D',
  Purple: '#804F9D',
}
export default ({ colors = [], color, onClick }) => (
  <ButtonGroupWrap>
    {colors.map((acolor, i) => (
      <ColorSwatch key={acolor.colorId || i} isSelected={color && color.colorId === acolor.colorId} colorId={acolor.colorId} colorName={acolor.displayName} colorCode={map[acolor.displayName] || acolor.displayName} onClick={onClick} />
    ))}
  </ButtonGroupWrap>
)
